import { faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faCalendarPlus as faCalendarPlusRegular } from '@fortawesome/free-regular-svg-icons';
import { faAngleDown, faAngleLeft, faAngleRight, faAngleUp, faArrowLeft, faArrowRight, faArrowDown, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faQuoteLeft, faPhone, faQuoteRight, faTimes as faXmark, faMinus as faMinusSign, faPlus as faPlusSign, faLocationDot } from '@fortawesome/free-solid-svg-icons';
export var iconLibraries = {
  FontAwesome: 'FontAwesome',
  SemanticUI: 'SemanticUI'
};
export var fontAwesomeIconMap = {
  tiktok: faTiktok,
  'arrow-down': faArrowDown,
  'arrow-left': faArrowLeft,
  'arrow-right': faArrowRight,
  'quote-left': faQuoteLeft,
  'quote-right': faQuoteRight,
  phone: faPhone,
  'chevron-left': faChevronLeft,
  'chevron-right': faChevronRight,
  'chevron-down': faChevronDown,
  'chevron-up': faChevronUp,
  xmark: faXmark,
  'angle-down': faAngleDown,
  'angle-up': faAngleUp,
  'angle-left': faAngleLeft,
  'angle-right': faAngleRight,
  minus: faMinusSign,
  plus: faPlusSign,
  'location-dot': faLocationDot,
  'calendar-plus-regular': faCalendarPlusRegular
};